module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAABEElEQVRoQ+1awRGCQAzcrUDtyA6kBEvQSmxBOrA0qCDOOejAKfe4u8jALC8+SZYlbG4z0Mz2AG4AGgDhvuS6A7iS7MZJXGqY2QPAqQRtFNuSPEfA69cwM6sIOqTqSB4i4PVrjIGTZO5DpPK41HBJGhHgUsMlqYBPG3dCshgfqVP8kbuQ45JUPa4enx9PGkCJ0S05nDtISQ6jttleq+QeaaO4nuTESTmc+Xuu2QEFdoJXPALYFbLeArjMeM66NQqBLhaebdUWQzwUFvB/v4GgKloIDaxrIZRovy60ymfLpIWQPKc8pzxn1rzanpGQHEoOJYeSQ8nhi4HVymHW+/sO0kIoQWT79px1lzW/f0KoWuMJdsZaL356nPYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon3.png
// module id = y9FJ
// module chunks = 1